// extracted by mini-css-extract-plugin
export var productImage = "_md-1";
export var viewLink = "_md-2";
export var wishlistItem = "_md-0";